// React
import React, { Component } from "react";
import PropTypes from "prop-types";
// Redux
import { connect } from "react-redux";
import { compose } from "redux";
// helpers
import cuid from "cuid";
// i18n
import { withNamespaces } from "react-i18next";
// Ducks
import { cancelBooking, getBookings } from "./Bookings.ducks";
// Components
import BookingItem from "./components/BookingItem";
import Modal from "../../../components/Modal";
import NoInformation from "../../../components/NoInformation";
import BookingsToolbar from "../components/BookingsToolbar";
import Notice from "../../../components/Notice";

class Bookings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookingToCancel: {},
      isModalOpen: false
    };
  }

  componentDidMount() {
    const { getBookings } = this.props;

    getBookings();
  }

  handleCancelButtonClick = (booking) => {
    this.setState({ isModalOpen: true, bookingToCancel: booking });
  };

  handleModalClose = () => {
    this.setState({ bookingToCancel: {}, isModalOpen: false });
  };

  handleModalConfirmButtonClick = () => {
    const { cancelBooking } = this.props;
    const { bookingToCancel } = this.state;

    cancelBooking(bookingToCancel.id);
    this.handleModalClose();
  };

  render() {
    const { bookings, t, isUserActive } = this.props;
    const { bookingToCancel, isModalOpen } = this.state;

    return (
      <div className="container" style={{ paddingBottom: 40 }}>
        {isUserActive === false && (
          <div style={{ marginTop: 40 }}>
            <Notice
              type="danger"
              message={t(
                `modules.localization.register.authenticated.smartNotifications.label.deletedCandidate`
              )}
            />
          </div>
        )}
        <Modal
          closeModal={this.handleModalClose}
          confirmAction={this.handleModalConfirmButtonClick}
          confirmActionLabel={t(
            `modules.localization.register.authenticated.bookings.button.confirm`
          )}
          cancelActionLabel={t(`modules.localization.register.generals.button.cancel`)}
          isOpen={isModalOpen}
          title={t(`modules.localization.register.authenticated.bookings.confirmCancellation`)}
        >
          {bookingToCancel.cancellationFee ? (
            <p>
              {t(`modules.localization.register.authenticated.bookings.cancellationMessage`, {
                cost: `${bookingToCancel.cancellationFee} ${
                  bookingToCancel.cancellationFeeCurrency
                }`
              })}
            </p>
          ) : (
            <p>
              {t(`modules.localization.register.authenticated.bookings.cancellationMessageFree`)}
            </p>
          )}
        </Modal>
        <BookingsToolbar />
        {bookings && !bookings.length && (
          <NoInformation
            label={t(`modules.localization.register.authenticated.bookings.emptyBooking`)}
          />
        )}
        <div className="col-sm-12">
          {bookings &&
            bookings.map((booking) => (
              <BookingItem
                data={booking}
                key={cuid()}
                onCancelClick={this.handleCancelButtonClick}
                isUserActive={isUserActive}
              />
            ))}
        </div>
      </div>
    );
  }
}

Bookings.propTypes = {
  bookings: PropTypes.array,
  cancelBooking: PropTypes.func.isRequired,
  getBookings: PropTypes.func.isRequired,
  isUserActive: PropTypes.bool,
  t: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  bookings: state.bookings.bookings,
  isUserActive: state.auth.profile.isUserActive
});

const mapDispatchToProps = {
  cancelBooking,
  getBookings
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNamespaces()
)(Bookings);
